import { DataRequest } from '@work4all/models/lib/DataProvider';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';
import { SdObjType } from '@work4all/models/lib/Enums/SdObjType.enum';

import { tryParseInit } from '../../../containers/mask-overlays/mask-overlay/utils/parse-template';

import { createSourceEntityRecordMatcherRequestData } from './create-source-entity-record-matcher-request-data';
import {
  TargetEntityRecordMatcherConfigs,
  UseEntityRecordMatcherProps,
} from './types';

type Props<TData> = Pick<
  UseEntityRecordMatcherProps,
  'sourceEntity' | 'sourceRecordIds' | 'targetEntity'
> & {
  config: TargetEntityRecordMatcherConfigs<TData>;
  skip: boolean;
};

type Return = DataRequest;

export const createSourceEntityRecordMatcherRequest = <TData>({
  sourceEntity,
  sourceRecordIds,
  targetEntity,
  config,
  skip,
}: Props<TData>): Return => {
  if (skip) {
    return {
      data: {},
      entity: sourceEntity,
      skip: true,
    };
  }

  const data = createSourceEntityRecordMatcherRequestData<TData>({
    sourceEntity,
    targetEntity,
    config,
  });

  // Parse template to create proper filter, similar to useAssignableTemplateEntity
  const template = tryParseInit(`${sourceEntity}:${sourceRecordIds.join(',')}`);

  // Create proper filter based on template
  let filter;
  if (!template?.entity || !template?.ids) {
    filter = [{ id: { $in: sourceRecordIds } }];
  } else {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const baseFilter: any = [{ id: { $in: template.ids } }];

    // Special handling for contact entities that need business partner info
    if (template.entity === Entities.contact) {
      if (template?.businessPartnerId && template.businessPartnerType) {
        baseFilter.push({
          businessPartnerId: { $eq: template.businessPartnerId },
          businessPartnerType: {
            $eq:
              template.businessPartnerType === Entities.customer
                ? SdObjType.KUNDE
                : SdObjType.LIEFERANT,
          },
        });
      }
    }

    filter = baseFilter;
  }

  return {
    data,
    entity: sourceEntity,
    filter,
  };
};
